<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <DataSidebar @ok="addProduct" :isSidebarActive="addNewDataSidebar" @closeSidebar="addNewDataSidebar = false" :options="addObj" />

    <vs-table ref="table"  pagination :max-items="itemsPerPage" :data="items">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="hidden cursor-pointer"  >

            <div class=" p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span>Delete</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Archive</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Print</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Another Action</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div class="p-3 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewDataSidebar = true">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ items.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : items.length }} of {{ items.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Name</vs-th>
        <vs-th sort-key="category">Cost/Ticket</vs-th>
        <!-- <vs-th sort-key="popularity">Sales so far</vs-th> -->
        <!-- <vs-th sort-key="order_status">Order Status</vs-th> -->
        <!-- <vs-th sort-key="price">Price</vs-th> -->
      </template>

        <template slot-scope="{data}" >
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <router-link :to="`/product/${tr.id}`" class="product-name font-medium">{{ tr.title }}</router-link>
              </vs-td>
              <vs-td>
                <p class="product-category">${{ tr.cost }}</p>
              </vs-td>
              <!-- <vs-td>
                ${{ tr.allTimeSales || 0 }}
              </vs-td> -->

              <vs-td>
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <feather-icon icon="MoreHorizontalIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>

                    <vs-dropdown-item @click="edit(tr)">
                      <span>Edit</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="del(tr)">
                      <span>Delete</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>

              <!-- <vs-td>
                <p class="product-price">${{ tr.price }}</p>
              </vs-td> -->

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataSidebar from '@/components/DataSidebar.vue';
import {arrToObj,notify,permissionFail} from '@/assets/helper'
export default {
  components: {
    DataSidebar
  },
  data() {
    return {
      addObj:{
        api:'/products',
        okText:'Add Product',
        label:'Product',
        fields:[
          {
            label:'Name',
            type:'text',
            field:'title',
            required:true
          },
          {
            label:'Cost per Credit',
            type:'number',
            field:'cost',
            required:true
          },
          {
            label:'Cost Type',
            type:'text',
            field:'costType',
            required:true
          },
          {
            label:'Cost Code',
            type:'text',
            field:'costCode',
          },

        ]
      },
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
    }
  },
  computed: {
    items(){
      return Object.values(this.products)
    },
    products(){
      return this.$store.state.products
    },
    currentPage() {
      if(this.isMounted) {
          if (this.$refs.table){
              return this.$refs.table.currentx
          }
      }
      return 0
    },
  },
  methods: {
    addProduct(pr){
      if (permissionFail(2)) return  this.addNewDataSidebar = false

      this.$create(`/products`, pr).then( ({data}) => {
        this.$store.commit('SET_PROP', {where:['products', data.id],what:data})
        this.addNewDataSidebar = false
        notify({
            title: 'Added',
            text:`Successfully Added Product!`,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position:'bottom-right'
        })
      })
    },
    edit(tr){

      if (permissionFail(2)) return 
      this.$router.push(`/product/${tr.id}`)
      
    },
    delConfirm(tr){
      this.$delete(`/products/${tr.id}`).then(x => {
        this.$store.commit('SET_PROP', {where:['products', tr.id], del:true})
        notify({
            title: 'Deleted',
            text:`Successfully Deleted!`,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position:'bottom-right'
        })
      })
      .catch( () => {
        notify({
            title: 'Error',
            text:`There was an error deleting!`,
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position:'bottom-right'
        })
      })
      console.log('del',tr)
    },
    del(tr){

      if (permissionFail(2)) return 


      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm Deletion`,
          text: 'You are about to delete an item. Please confirm that this is the action you want to perform.',
          accept: () => this.delConfirm(tr)
      })
      
    },
    getOrderStatusColor(status) {
      if(status == 'on hold') return "warning"
      if(status == 'delivered') return "success"
      if(status == 'canceled') return "danger"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    
  },
  created() {
    
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
